<template>
  <div class="alarmOrderTableCom ashComWrap">
    <div class="comTitle">
      <h4>{{ deviceType }}{{ type == "alarm" ? "报警" : "工单" }}</h4>
      <el-button
        type="text"
        style="color: #999999"
        @click="goPage"
        >更多 <i class="el-icon-d-arrow-right"></i
      ></el-button>
    </div>
    <div class="comContentBox tableCom">
      <ul class="cardList">
        <li v-for="(v, i) in cardList" :key="i">
          <p :style="{ color: v.color }">
            {{ v.name }}
          </p>
          <h5>{{ v.value }}</h5>
        </li>
      </ul>
      <div class="tabList">
        <el-table
          :data="tableData"
          height="100%"
          border
          stripe
          style="width: 100%"
          :cell-style="cellStyle"
          :header-cell-style="{
            'font-weight': 'bold',
            color: '#333',
            'background-color': '#F7F7F7',
          }"
          size="small"
        >
          <el-table-column
            v-for="(v, i) in tabHead"
            :key="i"
            :prop="v.prop"
            :label="v.label"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  matchingAlarmLevel,
  matchingOrderLevel,
  formatTime,
  matchingOrderColor,
  matchingAlarmColor,
} from "@/assets/js/utils";
export default {
  props: ["type", "deviceType"],
  data() {
    return {
      cardList: [],
      tableData: [],
      tabHead: [],
    };
  },
  methods: {
    goPage() {
      this.$router.push(
        this.type == "alarm" ? "/alarmManagement" : "/worksheets"
      );
    },
    cellStyle(row) {
      if (row.column.label === "报警级别") {
        return matchingAlarmColor(row.row.level);
      }
      if (row.column.label === "处理状态") {
        if (row.row.confirm == "未确认") {
          return "color:#28CCCB";
        }
      }
      if (row.column.label === "工单级别") {
        return matchingOrderColor(row.row.level);
      }
    },
    getCardList() {
      if (this.type == "alarm") {
        this.tabHead = [
          { label: "ID", prop: "alarmId" },
          { label: "报警时间", prop: "time" },
          { label: "设备名称", prop: "deviceName" },
          { label: "设备/区域地址", prop: "location" },
          { label: "处理状态", prop: "confirm" },
          { label: "报警级别", prop: "level" },
        ];
        this.getAlarmsList();
      } else if (this.type == "order") {
        this.tabHead = [
          { label: "工单ID", prop: "id" },
          { label: "工单名称", prop: "description" },
          { label: "工单级别", prop: "priority" },
          { label: "地点", prop: "location" },
          { label: "处理人", prop: "assignStaffNames" },
          { label: "处理时长", prop: "time" },
        ];
        this.getWorkOrderList();
      }
    },
    async getAlarmsList() {
      let res = await api.lightingOSGetAlarms({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.deviceType,
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.cardList = Array.from(res.data.data.statistics).map((item) => ({
          name: item.name == "total" ? "全部" : matchingAlarmLevel(item.name),
          value: item.value,
          color:
            item.name == "CRITICAL"
              ? "#EC5453"
              : item.name == "MAJOR"
              ? "#FF9400"
              : item.name == "MINOR"
              ? "#7895EA"
              : "#333",
        }));
        this.tableData = res.data.data.page.data;
        this.tableData.map((v) => {
          v.time = v.endTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime))
            : "";
          v.confirm = v.confirm ? "已确认" : "未确认";
          v.level = matchingAlarmLevel(v.level);
        });
      }
    },
    async getWorkOrderList() {
      let res = await api.lightingOSGetWorkOrder({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.deviceType,
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.cardList = Array.from(res.data.data.statistics).map((item) => ({
          name: item.name == "total" ? "全部" : matchingOrderLevel(item.name),
          value: item.value,
          color:
            item.name == "HIGH"
              ? "#EC5453"
              : item.name == "MEDIUM"
              ? "#FF9400"
              : item.name == "LOW"
              ? "#7895EA"
              : "#333",
        }));
        this.tableData = res.data.data.page.data;
        this.tableData.map((v) => {
          v.priority = matchingOrderLevel(v.priority);
          v.time = v.ts ? formatTime(v.ts) : "";
        });
      }
      // console.log(res);
    },
  },
  created() {
    this.getCardList();
  },
};
</script>

<style lang="scss" scoped>
.alarmOrderTableCom {
  width: 100%;
  height: 100%;
  .tableCom {
    .cardList {
      width: 96%;
      height: 65px;
      margin: 0 auto;
      @include setFlexBetween;
      li {
        width: 25%;
        height: 100%;
        @include setFlexColumn;
        align-items: center;
        justify-content: center;
        p {
          color: #333333;
          font-weight: 500;
          margin-bottom: 5px;
        }
        h5 {
          font-size: 20px;
          color: #666666;
          font-weight: 500;
        }
      }
    }
    .tabList {
      width: 96%;
      margin: 10px auto 0;
      height: calc(100% - 75px);
    }
  }
}
</style>
